"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "form-group row justify-content-left" };
const _hoisted_2 = { class: "col-md-4" };
const _hoisted_3 = {
    class: "form-control",
    disabled: "",
    readonly: ""
};
const _hoisted_4 = { class: "form-group row justify-content-left" };
const _hoisted_5 = { class: "col-md-4" };
const _hoisted_6 = {
    class: "form-control",
    disabled: "",
    readonly: ""
};
const _hoisted_7 = { class: "col-md-6" };
const _hoisted_8 = {
    class: "form-control",
    disabled: "",
    readonly: "",
    style: { "overflow": "hidden", "text-overflow": "ellipsis", "white-space": "nowrap" }
};
const _hoisted_9 = { class: "form-group row justify-content-left" };
const _hoisted_10 = { class: "col-md-6" };
const _hoisted_11 = { style: { "position": "relative" } };
const _hoisted_12 = { style: { "display": "flex", "position": "fixed" } };
const vue_basic_ui_1 = require("@xenodrive/vue-basic-ui");
const BssModal_vue_1 = __importDefault(require("@/components/BssModal.vue"));
const vue_3 = require("vue");
const moment_1 = __importDefault(require("moment"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'BssModalRequestVideo',
    props: {
        item: {},
        request: { type: Function }
    },
    setup(__props) {
        const props = __props;
        const requestVideoDate = (0, vue_3.ref)('');
        const movieDialogActive = (0, vue_3.ref)(false);
        (0, vue_3.watch)(movieDialogActive, (v) => __awaiter(this, void 0, void 0, function* () {
            if (v) {
                requestVideoDate.value = (0, moment_1.default)(Date.now()).format('YYYY/MM/DD HH:mm:ss');
                yield (0, vue_3.nextTick)();
                window.initialize_datepicker('datetime-seconds');
            }
        }));
        const loading = (0, vue_3.ref)(false);
        function requestVideo(close) {
            return __awaiter(this, void 0, void 0, function* () {
                loading.value = true;
                try {
                    if (yield props.request(requestVideoDate.value)) {
                        window.toastr.success('動画を要求しました');
                        close();
                    }
                    else {
                        // サーバーが受け付けを断った場合。通信自体は成功しているので例外にならず、
                        // ここで知らせないと「押したのに何も起きない」画面になる。
                        // 入力を直して再操作できるよう、モーダルは閉じない。
                        window.toastr.error('動画の要求に失敗しました');
                    }
                }
                catch (e) {
                    console.error(e);
                    window.toastr.error('動画の要求に失敗しました');
                }
                finally {
                    loading.value = false;
                }
            });
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(BssModal_vue_1.default, {
                modelValue: movieDialogActive.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((movieDialogActive).value = $event)),
                title: "動画要求"
            }, {
                trigger: (0, vue_2.withCtx)(() => [
                    (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.Button), {
                        icon: "fa:video",
                        rounded: "",
                        "icon-size": "1rem",
                        style: { "padding": "0.25rem 0.5rem", "border": "1px solid #ccc", "font-size": "0.85em" }
                    }, {
                        default: (0, vue_2.withCtx)(() => [...(_cache[2] || (_cache[2] = [
                                (0, vue_2.createTextVNode)("  動画要求 ", -1)
                            ]))]),
                        _: 1
                    })
                ]),
                footer: (0, vue_2.withCtx)(({ close }) => [
                    (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.Button), {
                        style: { "padding": "0.375rem 0.75rem", "font-size": "1rem", "line-height": "1.5", "border-radius": "0.25rem" },
                        onClick: (0, vue_2.withModifiers)(close, ["stop"])
                    }, {
                        default: (0, vue_2.withCtx)(() => [...(_cache[9] || (_cache[9] = [
                                (0, vue_2.createTextVNode)(" 戻る ", -1)
                            ]))]),
                        _: 1
                    }, 8, ["onClick"]),
                    (0, vue_2.createVNode)((0, vue_2.unref)(vue_basic_ui_1.Button), {
                        style: { "padding": "0.375rem 0.75rem", "font-size": "1rem", "line-height": "1.5", "border-radius": "0.25rem" },
                        color: "#4c87c7",
                        onClick: (0, vue_2.withModifiers)(($event) => (requestVideo(close)), ["stop"])
                    }, {
                        default: (0, vue_2.withCtx)(() => [...(_cache[10] || (_cache[10] = [
                                (0, vue_2.createTextVNode)(" 実行 ", -1)
                            ]))]),
                        _: 1
                    }, 8, ["onClick"])
                ]),
                default: (0, vue_2.withCtx)(() => {
                    var _a, _b, _c;
                    return [
                        (0, vue_2.createElementVNode)("div", _hoisted_1, [
                            (0, vue_2.createElementVNode)("div", _hoisted_2, [
                                _cache[3] || (_cache[3] = (0, vue_2.createElementVNode)("label", { class: "input-label" }, "営業所", -1)),
                                (0, vue_2.createElementVNode)("div", _hoisted_3, (0, vue_2.toDisplayString)(((_a = props.item) === null || _a === void 0 ? void 0 : _a.section_name) || '(不明)'), 1)
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                            (0, vue_2.createElementVNode)("div", _hoisted_5, [
                                _cache[4] || (_cache[4] = (0, vue_2.createElementVNode)("label", { class: "input-label" }, "車両コード", -1)),
                                (0, vue_2.createElementVNode)("div", _hoisted_6, (0, vue_2.toDisplayString)((_b = props.item) === null || _b === void 0 ? void 0 : _b.vehicle_code), 1)
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                _cache[5] || (_cache[5] = (0, vue_2.createElementVNode)("label", { class: "input-label" }, "車両名", -1)),
                                (0, vue_2.createElementVNode)("div", _hoisted_8, (0, vue_2.toDisplayString)((_c = props.item) === null || _c === void 0 ? void 0 : _c.vehicle_name), 1)
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_9, [
                            (0, vue_2.createElementVNode)("div", _hoisted_10, [
                                _cache[7] || (_cache[7] = (0, vue_2.createElementVNode)("label", { class: "input-label" }, "要求する日時", -1)),
                                _cache[8] || (_cache[8] = (0, vue_2.createElementVNode)("div", { class: "badge bg-danger badge-required" }, "必須", -1)),
                                (0, vue_2.createElementVNode)("div", _hoisted_11, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_12, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((requestVideoDate).value = $event)),
                                            class: "datetime-seconds-picker form-control harf-char",
                                            type: "text",
                                            autocomplete: "off"
                                        }, null, 512), [
                                            [vue_2.vModelText, requestVideoDate.value]
                                        ])
                                    ]),
                                    _cache[6] || (_cache[6] = (0, vue_2.createElementVNode)("div", { style: { "height": "2rem" } }, null, -1))
                                ])
                            ])
                        ])
                    ];
                }),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});
